import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  StyledLine,
  StyledLineInside,
  Title,
  ListElement,
  AuthorAndTime,
  Rating,
  FlexContainer
} from '../common/StyledComponents';
import { rootConfig } from '../../config/config';
import { SideBarCardData } from '../common/StyledComponents/StyledSideBar';

const ReviewsOnHomePage = props => {
  // console.log('props: ', props);
  const { title, listItems, maxwidth } = props;

  let cardItems = listItems.map((listItem, index) => {
    return (
      <FlexContainer
        className={
          // index === 0 || index === 1
          //   ? 'pointer w-50-l w-100-m w-100'
          //   : 'pointer w-third-l w-100-m w-100'
          index === 0
            ? 'pointer w-50-l w-100-m w-100'
            : index === 1
            ? 'pointer w-50-l w-50-m w-100'
            : 'pointer w-third-l w-50-m w-100'
        }
        direction="column"
        style={{
          // width: index === 0 || index === 1 ? '50%' : '33%',
          padding: '0.875rem 0.5rem'
        }}
        key={listItem.id}
        onClick={() => navigate(listItem.postSlug)}
      >
        <div className="ImageDiv relative">
          {listItem.rating ? (
            <FlexContainer className="Rating">
              <Rating
                className="absolute right-0"
                width="50px"
                height="50px"
                padding="12px"
                background="#4db2ec"
              >
                <Title
                  className="Rating-Text"
                  fontFamily="Montserrat"
                  fontSize="2.25rem"
                  color="#fff"
                >
                  {listItem.rating}
                </Title>
              </Rating>
            </FlexContainer>
          ) : null}
          <div
            style={{
              // width: index === 0 || index === 1 ? '480px' : '300px',
              // minWidth: '300px',
              // width: index === 0 || index === 1 ? '100%' : '100%',
              // maxWidth: '480px',
              // height: index === 0 || index === 1 ? '240px' : '150px',
              // minHeight: '150px',
              // height: `100%`,
              // maxHeight: '240px',
              // background: `url(${rootConfig.imagesRoot}/${
              //   listItem.featuredImage.file
              // })`,
              background: `${
                listItem.featuredImage
                  ? `url(${rootConfig.imagesRoot}/${
                      listItem.featuredImage.file
                    })`
                  : 'black'
              }`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
            className={
              index === 0 || index === 1
                ? 'home-review-image'
                : 'home-review-image home-review-image-150'
            }
          />
        </div>
        <SideBarCardData className="h-100">
          <Title
            className="pt2"
            fontFamily="Nunito"
            fontSize="1.25rem"
            fontWeight="bold"
            lineHeight="1.2"
          >
            {listItem.postTitle}
          </Title>
          <AuthorAndTime
            color="#757575"
            fontFamily="Montserrat"
            fontSize="0.75rem"
            fontWeight="normal"
            padding="0.8rem 0 0 0"
          >
            <div>{listItem.postAuthor.authorName}</div>
            <div>{listItem.postDate}</div>
          </AuthorAndTime>
        </SideBarCardData>
      </FlexContainer>
    );
  });

  const navigate = postSlug => {
    postSlug = postSlug.toLowerCase();
    // console.log('postSlug: ', postSlug);
    props.history.push(`/${postSlug}`);
  };

  return (
    <div className={props.className}>
      <ListElement
        className="w-100"
        padding="2.25rem 1.2rem"
        maxwidth={maxwidth}
      >
        <Title
          className="pointer"
          onClick={() => navigate(`reviews`)}
          fontFamily="Montserrat"
          fontSize="2.25rem"
          fontWeight="bold"
        >
          {title}
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine>
        <FlexContainer className="flex-wrap justify-center">
          {cardItems}
        </FlexContainer>
      </ListElement>
    </div>
  );
};

export default withRouter(ReviewsOnHomePage);
